import taskpane from '../taskpane/components/taskpane'
import FirstRun from '../taskpane/components/elements/FirstRun'
import { initializeIcons } from '@fluentui/font-icons-mdl2'
import { ThemeProvider } from '@fluentui/react'
import * as React from 'react'
import { createRoot } from 'react-dom/client'
import { WranglesProvider } from '@wrangleworks/wranglesjs'
import { LayerProvider } from './LayerProvider'
import { FluentProvider } from '@fluentui/react-components'
// For v9 react component styling to work inside v8 react portals (panels, dialogs, etc.) this package is needed for compatibility.
// https://react.fluentui.dev/iframe.html?viewMode=docs&id=concepts-migration-from-v8-troubleshooting--docs#i-tried-using-the-new-components-inside-v8-callouts-panels-etc-but-there-does-not-seem-to-be-any-styling-applied-to-them-am-i-doing-something-wrong
import { PortalCompatProvider } from '@fluentui/react-portal-compat'
import { lightTheme } from '../taskpane/utils/theme'
import { lightCustomTheme } from '../taskpane/utils/customTheme'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { getNotesRoutes } from '../runtimeConfig'

// Find if this is the user's first time opening the add-in
var shownFirstRun = 'false'
try {
  shownFirstRun = localStorage.getItem('wrwx/wrangles/shownFirstRun')
} catch {
  // If this fails and local storage isn't available for some reason
  // then skip showing first run page to avoid repeated showing.
  shownFirstRun = 'true'
}

const placeholder = (
  <img
    id="wrangleworks-loading"
    src="/assets/gifs/animated_wrwx.gif"
    title="test"
    style={{
      width: '250px',
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
    }}
  />
)
/* global document, Office, module, require */

initializeIcons()

let isOfficeInitialized = false

const root = createRoot(document.getElementById('container'))

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
})

const render = (Component) => {
  root.render(
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={lightTheme}>
        <FluentProvider theme={lightCustomTheme}>
          <PortalCompatProvider>
            <LayerProvider>
              <WranglesProvider
                routes={getNotesRoutes()}
                init={{
                  onLoad: 'login-required',
                  silentCheckSsoRedirectUri:
                    window.location.origin + '/silent-check-sso.html',
                }}
                config={{
                  url: 'https://sso.wrangle.works/auth',
                  realm: 'wrwx',
                  clientId: 'wranglesXL',
                }}
                placeholder={placeholder}
              >
                {isOfficeInitialized ? (
                  <Component myWranglesPath="/wrangles.html" />
                ) : (
                  <p>Please sideload your add-in to see app body.</p>
                )}
              </WranglesProvider>
            </LayerProvider>
          </PortalCompatProvider>
        </FluentProvider>
      </ThemeProvider>
    </QueryClientProvider>
  )
}

const renderFirstRun = () => {
  root.render(
    <ThemeProvider>
      <FirstRun></FirstRun>
    </ThemeProvider>
  )
}

/* Render application after Office initializes */
Office.initialize = () => {
  isOfficeInitialized = true

  if (shownFirstRun == 'true') {
    render(taskpane)
  } else {
    renderFirstRun()
  }
}

if ((module as any).hot) {
  ;(module as any).hot.accept('../taskpane/components/taskpane.tsx', () => {
    const NextApp = require('../taskpane/components/taskpane.tsx').default
    render(NextApp)
  })
}
